import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * A reusable confirmation modal for any action.
 * 
 * @param {boolean} show - Whether to show the modal
 * @param {function} onHide - Function to call when hiding the modal (cancel)
 * @param {function} onConfirm - Function to call when confirming the action
 * @param {string} title - Modal title
 * @param {string} message - Modal body message
 * @param {string} confirmText - Text for the confirm button
 * @param {string} cancelText - Text for the cancel button
 * @param {string} confirmVariant - Bootstrap variant for the confirm button (e.g., 'primary', 'danger', 'success')
 * @param {boolean} isLoading - Whether the action is currently in progress
 */
const ConfirmationModal = ({
    show,
    onHide,
    onConfirm,
    title = 'Confirm Action',
    message = 'Are you sure you want to perform this action?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmVariant = 'primary',
    isLoading = false
}) => {
    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton={!isLoading}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center">
                    {confirmVariant === 'danger' && (
                        <i className="fas fa-exclamation-triangle text-danger me-3 fs-3"></i>
                    )}
                    {confirmVariant === 'warning' && (
                        <i className="fas fa-exclamation-circle text-warning me-3 fs-3"></i>
                    )}
                    {confirmVariant === 'success' && (
                        <i className="fas fa-check-circle text-success me-3 fs-3"></i>
                    )}
                    {confirmVariant === 'primary' && (
                        <i className="fas fa-question-circle text-primary me-3 fs-3"></i>
                    )}
                    <p className="mb-0">{message}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isLoading}>
                    {cancelText}
                </Button>
                <Button variant={confirmVariant} onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Processing...
                        </>
                    ) : confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
